// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/SuperChatSuite/index.css
// module id = 2468
// module chunks = 0